import SupportedLobModules from 'integration/policycommon/SupportedLobModules';

export default angular.module('edge.policycommon.app', SupportedLobModules);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/app.js
// module id = 124
// module chunks = 0